<div class="question-container">
  <p class="question">{{title}}</p>
  <button class="pgh-tooltip" *ngIf="moreInfo" sf-aria-label="Global_MoreInfo_Aria_Label">
    <span class="pgh-tooltip-content" [innerHTML]="moreInfo"></span>
    <mat-icon svgIcon="circle-alert"></mat-icon>
  </button>
</div>

<mat-radio-group *ngIf="!deviceInfo" aria-labelledby="radio-group-label" class="radio-group" color="primary"
  [(ngModel)]="answer" (ngModelChange)="chooseAnswer.emit($event)">
  <mat-radio-button [value]="i" class="example-radio-button" *ngFor="let option of options; let i = index">
    {{option.label}}
  </mat-radio-button>
</mat-radio-group>

<form [formGroup]="claimsForm">
  <div class="device-info" *ngIf="deviceInfo">
    <mat-form-field>
      <mat-label>{{categoriesDropdown.label}}</mat-label>
      <mat-select formControlName='category'>
        <mat-option value="" disabled>
          {{categoriesDropdown?.placeHolder}}
        </mat-option>
        <mat-option *ngFor="let option of categoriesDropdownOptions" [value]="option">
          {{option.name}}
        </mat-option>
        <mat-option disabled *ngIf="categoriesDropdownOptions.length === 0">
          No Categories Found
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-error class="device-type-error" *ngIf="categoriesDropdownOptions.length === 0">
      We're sorry. Categories cannot be found for your claim type. Please contact customer support (1-877-307-9215) for
      help.
    </mat-error>
    <mat-form-field *ngIf="!isGSSP" [hidden]="isSubCategoryHidden()">
      <mat-label>{{subCategoriesDropdown.label}}</mat-label>
      <mat-select formControlName='subCategory'>
        <mat-option value="" disabled>
          {{subCategoriesDropdown.placeholder}}
        </mat-option>
        <mat-option *ngFor="let option of getSubcategories()" [value]="option">
          {{option.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <input maxlength="30" matInput [placeholder]="brandsSearchBox.label" [matAutocomplete]="auto" autocomplete="on"
        formControlName='brand'>
    </mat-form-field>
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngIf="isLoading" class="is-loading">
        <mat-spinner diameter="20"></mat-spinner>
      </mat-option>
      <ng-container *ngIf="!isLoading">
        <mat-option *ngFor="let brand of filteredBrands" [value]="brand.brandName">
          <span>{{brand.brandName}}</span>
        </mat-option>
        <mat-option disabled
          *ngIf="claimsForm?.get('brand')?.value?.length > 1 && filteredBrands.length === 0 && !isLoading">
          No Results Found
        </mat-option>
      </ng-container>
    </mat-autocomplete>
    <mat-error class="brand-error"
      *ngIf="customDirty && claimsForm?.get('brand')?.value.length > 0 && claimsForm?.get('brand')?.dirty && !isLoading && claimsForm?.get('brand')?.errors?.requireMatch">
      {{brandsSearchBox.errorMessage}}</mat-error>
    <mat-form-field>
      <input maxlength="30" matInput [placeholder]="modelTextBox.label" formControlName='model'>
    </mat-form-field>
    <ng-container *ngIf="isGSSP">
      <mat-form-field>
        <input maxlength="30" matInput [placeholder]="deviceNameTextBox.label" formControlName='deviceName'>
      </mat-form-field>
      <mat-form-field>
        <input maxlength="30" matInput [placeholder]="serialNumberTextBox.label" formControlName='serialNumber'>
      </mat-form-field>
      <mat-form-field>
        <input matInput appCurrencyInput [maxDigits]="purchasePriceTextBox?.maxLength" [placeholder]="purchasePriceTextBox.label"
          formControlName='purchasePrice'>
      </mat-form-field>
      <mat-form-field id="purchaseDate" class="col-12 col-md-6">
        <mat-label class="field-label">{{ purchaseDateTextBox.label }}</mat-label>
        <input inputmode="numeric" autocomplete="purchase-date" matInput class="field-input"
          formControlName="purchaseDate" [matDatepicker]="dp" placeholder="MM/DD/YYYY" [min]="minDate" [max]="maxDate"
          numbersOnly />
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp #picker startView="month" panelClass="example-month-picker">
        </mat-datepicker>
        <mat-error class="custom-mat-error" pgh-input-error controlName="purchaseDate"
          [errorMessages]="{maxDate: 'The purchase date must be in the past'}" [label]="purchaseDateTextBox.label">
        </mat-error>
      </mat-form-field>
    </ng-container>

    <p>{{finalText}}</p>
    <div>
      <button class="d-inline" mat-flat-button color="accent" [disabled]="!claimsForm.valid || isClaimLoading"
        (click)="submitClaim()">{{buttonText}}</button>
      <mat-spinner *ngIf="isClaimLoading" class="contract-loading d-inline ml-10" [diameter]="25"></mat-spinner>
    </div>
    <div *ngIf="isNative" class="mbottom"></div>
  </div>
</form>

<mat-divider *ngIf="divider"></mat-divider>
